
import { Component, Inject, Vue, Emit, Watch } from "vue-property-decorator";
import { Container } from "inversify";
import { ConferenceListStore } from "../../stores/conference/ConferenceListStore";
import NoRecords from "../../../../common/src/components/NoRecords.vue";
import LoadingOverlay from "../../../../common/src/components/LoadingOverlay.vue";
import { ConferenceCollectionStore } from "../../stores/conference/ConferenceCollectionStore";
import { Conference } from "@gsx/common";
import { enrichedColumns } from "../../utils/tableUtils";
import { handleError } from "../../../../common/src/utility/errorUtils";
import { ConferenceFilterStore } from "../../stores/conference/ConferenceFilterStore";
import { debounce } from "debounce";

interface Column {
    id?: keyof Conference;
    name: string;
}

@Component({
    components: { LoadingOverlay, NoRecords },
})
export default class ConferenceTable extends Vue {
    @Inject("container") readonly container!: Container;
    listStore: ConferenceListStore = this.container.get("ConferenceTableListStore");
    collectionStore: ConferenceCollectionStore = this.container.get(ConferenceCollectionStore);
    conferenceFilterStore: ConferenceFilterStore = this.container.get(ConferenceFilterStore);

    readonly columns: ReadonlyArray<Column> = [
        {
            id: "name",
            name: "Name",
        },
        {
            id: "startDate",
            name: "Start Date",
        },
        {
            id: "endDate",
            name: "End Date",
        },
        {
            id: "topics",
            name: "Topics",
        },
        {
            id: "country",
            name: "Country",
        },
        {
            id: "city",
            name: "City",
        },
    ];

    created() {
        this.listStore.afterDate = new Date();
        this.listStore.pageSize = 10;
        this.listStore.load().catch(handleError);
    }

    @Emit("eventClick")
    handleEventClick(eventId: any) {
        return this.listStore.items?.find((conference) => conference.conferenceid === eventId);
    }

    get enrichedColumns() {
        return enrichedColumns(this.collectionStore, this.columns);
    }

    @Watch("listStore.query")
    @Watch("conferenceFilterStore.topics")
    @Watch("conferenceFilterStore.types")
    @Watch("conferenceFilterStore.countries")
    @Watch("conferenceFilterStore.cities")
    @Watch("conferenceFilterStore.logicalOperator")
    reloadDebounce = debounce(this.reload, 300);

    reload() {
        this.listStore.reload().catch(handleError);
    }
}
